import {create} from "zustand";

export const useProfileOnboardingStore = create(set => ({
  forceOpen: false,
  requestOpen: () => set({forceOpen: true}),
  clearForceOpen: () => set({forceOpen: false}),
}));
